export const PROPS_FULL_NAME = "fullName";
export const PROPS_GUID = "guid";
export const PROPS_HIERARCHY_ENTITIES = "hierarchyEntities";
export const PROPS_USER_GUID = "userGuid";
export const PROPS_USER_ROLES = "userRoles";
export const PROPS_USERS = "users";
export const PROPS_VALUE = "value";
